export const parsePatronOptionToSlug = (trait) => {
    switch (trait) {
        case 'Family_Friendly':
            return 'FamilyFriendly'
        case 'Pets':
            return 'Pets'
        case 'Dogs':
            return 'Pets'
        case 'WiFi_Available':
            return 'HeroIcons.Wifi'
        case 'All_Pets':
            return 'Pets'
        default:
            break
    }
}
